<template>
  <div class="info-item">
    <div class="flex items-center justify-between">
      <div class="flex-1">
        <dt class="text-sm font-medium text-gray-500 dark:text-gray-400">
          {{ label }}
        </dt>
        <dd class="mt-1 text-sm text-gray-900 dark:text-gray-100">
          <slot name="value">
            <slot>{{ value }}</slot>
          </slot>
        </dd>
      </div>
      <div v-if="$slots.action" class="ml-4">
        <slot name="action"></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    default: '',
  },
});
</script>

<style scoped>
.info-item {
  padding: 1rem 0;
}

.info-item:not(:last-child) {
  border-bottom: 1px solid #e5e7eb;
}

.dark .info-item:not(:last-child) {
  border-bottom-color: #374151;
}
</style>
